import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

const fetchCount = (url) => api.get(url).then((r) => r.data.length).catch(() => 0);

export function useDashboardData(user) {
  const [listings, setListings] = useState([]);
  const [counts, setCounts] = useState({ favorites: 0, messages: 0 });

  useEffect(() => {
    if (!user) return;
    api.get("/me/listings").then(({ data }) => setListings(data));
    Promise.all([fetchCount("/me/favorites"), fetchCount("/messages/threads")])
      .then(([favorites, messages]) => setCounts({ favorites, messages }));
  }, [user]);

  const remove = useCallback(async (id) => {
    await api.delete(`/listings/${id}`);
    setListings((p) => p.filter((l) => l.listing_id !== id));
  }, []);

  const repost = useCallback(async (id) => {
    const { data } = await api.post(`/listings/${id}/repost`);
    setListings((p) => [data, ...p.filter((l) => l.listing_id !== id)]);
  }, []);

  const stats = {
    total: listings.length,
    views: listings.reduce((sum, l) => sum + (l.views || 0), 0),
    ...counts,
  };

  return { listings, stats, remove, repost };
}
